/*
  Regel-verzamelaar voor het productformulier van het thema.

  Blokken op de productpagina die iets extra's aan de winkelwagen willen toevoegen (de bundel,
  een add-on) hoeven de koopknop niet te vervangen en hoeven niets van elkaar te weten. Bij het
  versturen van het formulier zendt dit bestand op `document` de gebeurtenis
  `product-form:collect-lines` uit. Een blok reageert daarop met:

    event.detail.replaceMain(lines)  - vervang de hoofdregel (bijv. de bundel: N stuks)
    event.detail.addLine(line)       - voeg een extra regel toe (bijv. een add-on)
    event.detail.cancel()            - stop het versturen (bijv. verplichte tekst ontbreekt)

  Een regel is { id, quantity, properties: { naam: waarde } }. Controleer met
  `section.contains(event.detail.form)` dat de gebeurtenis bij jouw pagina hoort.

  Reageert er niemand, dan blijft het formulier ongewijzigd en werkt de koopknop als altijd. Zo
  wel, dan schrijft dit bestand alle regels als verborgen items[n][...]-velden in het formulier
  (Ajax Cart API, multi-item add) en verstuurt het thema ze zoals normaal, inclusief het openen
  van de winkelwagenlade.
*/

if (!window.productFormLines) {
  window.productFormLines = true;

  const FORM = 'product-form form[action*="/cart/add"]';
  const OWN_FIELD = 'data-form-line';

  // De hoofdregel zoals het formulier hem nu zou versturen (variant, aantal, eigenschappen).
  function mainLinesFromForm(form) {
    const data = new FormData(form);
    const id = data.get('id');
    if (!id) return [];

    const line = { id, quantity: Number(data.get('quantity')) || 1, properties: {} };
    data.forEach((value, name) => {
      const match = name.match(/^properties\[(.*)\]$/);
      if (match && typeof value === 'string' && value !== '') line.properties[match[1]] = value;
    });
    const plan = data.get('selling_plan');
    if (plan) line.selling_plan = plan;
    return [line];
  }

  function addHidden(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(OWN_FIELD, '');
    form.append(input);
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches(FORM)) return;

      const detail = {
        form,
        mainLines: mainLinesFromForm(form),
        extraLines: [],
        changed: false,
        canceled: false,
        replaceMain(lines) {
          this.mainLines = lines;
          this.changed = true;
        },
        addLine(line) {
          this.extraLines.push(line);
          this.changed = true;
        },
        cancel() {
          this.canceled = true;
        },
      };
      document.dispatchEvent(new CustomEvent('product-form:collect-lines', { detail }));

      if (detail.canceled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (!detail.changed) return;

      form.querySelectorAll(`[${OWN_FIELD}]`).forEach((el) => el.remove());
      [...detail.mainLines, ...detail.extraLines].forEach((line, i) => {
        addHidden(form, `items[${i}][id]`, line.id);
        addHidden(form, `items[${i}][quantity]`, line.quantity);
        if (line.selling_plan) addHidden(form, `items[${i}][selling_plan]`, line.selling_plan);
        Object.entries(line.properties || {}).forEach(([name, value]) => {
          addHidden(form, `items[${i}][properties][${name}]`, value);
        });
      });

      // De losse velden van het formulier mogen niet naast items[] meegaan; na het versturen terug.
      const originals = [...form.querySelectorAll('[name="id"], [name="quantity"], [name="selling_plan"], [name^="properties["]')]
        .filter((el) => !el.hasAttribute(OWN_FIELD));
      originals.forEach((el) => (el.disabled = true));
      setTimeout(() => originals.forEach((el) => (el.disabled = false)), 0);
    },
    true
  );
}
